/**
 * @param {string} amount
 */
function togglePaybright(amount, hasGiftCardInCart) {
    var paybrightPrice = document.getElementById('paybrightprices');
    // Checking the mulitple iframes is intialized or not
    // if mulitple are there we are removing next all the div except one
    var pbModalLength = document.querySelectorAll('[id=pbModal]').length;
    if (pbModalLength > 1) {
        $('#pbModal').nextAll().remove();
    }

    // skip if price is not found or there is any gift card in the cart
    if (!paybrightPrice || hasGiftCardInCart) {
        if (!$('#paybright_prequalify_div').hasClass('d-none')) {
            $('#paybright_prequalify_div').addClass('d-none');
            $('#svg-svg-paybright-prequalify').addClass('d-none');
        }
        return;
    }

    var min = convertToFloat(paybrightPrice.getAttribute('data-paybrightMin'));
    var max = convertToFloat(paybrightPrice.getAttribute('data-paybrightMax'));
    if (convertToFloat(amount) >= min && convertToFloat(amount) <= max) {
        $(' #paybright_prequalify_div').removeClass('d-none');
        $('#svg-svg-paybright-prequalify').removeClass('d-none');
        document.getElementById('paybright_prequalify_div').setAttribute('data-pb_financedamount', amount);
        try {
            window.pb_prequalify_init({
                triggerElement: 'Link',
                triggerClass: 'paybright-widget-container',
                noFiguresInModal: false,
                showDecimals: true,
                triggerText: window.globalData.site.locale === 'fr_CA' ? 'En savoir plus' : 'Learn More',
                hideTriggerLeadText: false
            });
        } catch (err) {

        }
    } else {
        $(' #paybright_prequalify_div').addClass('d-none');
        $('.svg-svg-paybright').addClass('d-none');
    }
}

/**
 * To convert string to float
 */
function convertToFloat(val) {
    if (val !== '') {
        val = parseFloat(val);
    }
    return val;
}

/**
 * To disable paybright payment option
 */
function disablePaybrightOption() {
    // diable Paybright payment option
    $('li.nav-item.paybright-payment-item').addClass('paypal-disable');
    $('#paybrightPaymentspay_over_timeRadioButton').attr('disabled', true);
}

/**
 * To enable paybright payment option
 */
function enablePaybrightOption() {
    // diable Paybright payment option
    $('li.nav-item.paybright-payment-item').removeClass('paypal-disable');
    $('#paybrightPaymentspay_over_timeRadioButton').removeAttr('disabled');
}

module.exports = {
    togglePaybright: togglePaybright,
    disablePaybrightOption: disablePaybrightOption,
    enablePaybrightOption: enablePaybrightOption
};
